import { version } from '../../../../package.json'
export default {
  namespaced: true,
  state: {
    isLoading: false,
    acl: {},
    enableAutoCompleteForUserData: false,
    cancelledDailyPlanItemColor: null,
    activeDailyPlanItemColor: null,
    movedDailyPlanItemColor: null,
    returnedDailyPlanItemColor: null,
    idClientTypeForContractorsView: null,
    isHeadquartersForContractorsView: 0,
    addressTypeOptions: [],
    defaultAddressType: 1,
    postcode: null,
    invoiceSettings: [],
    titlePartOne: null,
    nip: null,
    street: null,
    numberLocal: null,
    place: null,
    city: null,
    bankAccount: null,
    mailerLiteStatus: 0,
    crmCallPhonePath: '',
    customClientTypeIds: [],
    clientTypesForPartnerUserData: [],
    version: version,
    ksefEnabled: 0
  },
  getters: {
    acl: (state) => state.acl,
    enableAutoCompleteForUserData: (state) => state.enableAutoCompleteForUserData,
    cancelledDailyPlanItemColor: (state) => state.cancelledDailyPlanItemColor,
    activeDailyPlanItemColor: (state) => state.activeDailyPlanItemColor,
    movedDailyPlanItemColor: (state) => state.movedDailyPlanItemColor,
    returnedDailyPlanItemColor: (state) => state.returnedDailyPlanItemColor,
    titlePartOne: (state) => state.titlePartOne,
    postcode: (state) => state.postcode,
    nip: (state) => state.nip,
    street: (state) => state.street,
    numberLocal: (state) => state.numberLocal,
    place: (state) => state.place,
    city: (state) => state.city,
    bankAccount: (state) => state.bankAccount,
    autoTakeTaskAfterEnter: (state) => state.autoTakeTaskAfterEnter,
    idClientTypeForContractorsView: (state) => state.idClientTypeForContractorsView,
    isHeadquartersForContractorsView: (state) => state.isHeadquartersForContractorsView,
    addressTypeOptions: (state) => state.addressTypeOptions,
    invoiceSettings: (state) => state.invoiceSettings,
    defaultAddressType: (state) => state.defaultAddressType,
    mailerLiteStatus: (state) => state.mailerLiteStatus,
    crmCallPhonePath: (state) => state.crmCallPhonePath,
    customClientTypeIds: (state) => state.customClientTypeIds,
    clientTypesForPartnerUserData: (state) => state.clientTypesForPartnerUserData,
    ksefEnabled: (state) => state.ksefEnabled,
    version: (state) => state.version,
    isLoading: (state) => state.isLoading
  },
  mutations: {
    setConfiguration (state, configuration) {
      Object.assign(state, configuration)
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    }
  },
  actions: {
  }
}
